export { VinSummaryCard } from "./VinSummaryCard";
export type { VinSummaryCardProps } from "./VinSummaryCard";
